import Heading from 'components/Basic/Heading/Heading';
import ProductsSlider from 'components/Blocks/Product/ProductsSlider';
import { useTypedTranslationFunction } from 'hooks/typescript/UseTypedTranslationFunction';
import { SliderProductItemType } from 'types/product';

type ProductDetailRelatedProps = {
    relatedProducts: SliderProductItemType[];
};

const ProductDetailRelated: FC<ProductDetailRelatedProps> = ({ relatedProducts }) => {
    const t = useTypedTranslationFunction();

    return (
        <>
            <Heading type="h2">{t('You might also like it')}</Heading>
            <ProductsSlider products={relatedProducts} gtmListName="related" />
        </>
    );
};

export default ProductDetailRelated;
